import { render } from "./ChildDevelopmentsContainer.vue?vue&type=template&id=144437d0&ts=true"
import script from "./ChildDevelopmentsContainer.vue?vue&type=script&lang=ts"
export * from "./ChildDevelopmentsContainer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__